import { PlanTypes } from 'mbs-ui-shared@models/PlanTypes.enum';
import { BackupFilesWizardComponent } from 'wizards/remote-management-wizards/backup-files-wizard/backup-files-wizard.component';
import { ConsistencyCheckWizardComponent } from 'wizards/remote-management-wizards/consistency-check-wizard/consistency-check-wizard.component';
import { DatabaseRestoreWizardComponent } from 'wizards/remote-management-wizards/database-restore-wizard/database-restore-wizard.component';
import { HyperVWizardComponent } from 'wizards/remote-management-wizards/hyper-v-wizard/hyper-v-wizard.component';
import { ImageBasedRestoreWizardComponent } from 'wizards/remote-management-wizards/image-based-restore-wizard/image-based-restore-wizard.component';
import { ImageBasedWizardComponent } from 'wizards/remote-management-wizards/image-based-wizard/image-based-wizard.component';
import { ProxmoxBackupWizardComponent } from 'wizards/remote-management-wizards/proxmox-backup-wizard/proxmox-backup-wizard.component';
import { ProxmoxRestoreWizardComponent } from 'wizards/remote-management-wizards/proxmox-restore-wizard/proxmox-restore-wizard.component';
import { RestoreFileWizardComponent } from 'wizards/remote-management-wizards/restore-file-wizard/restore-file-wizard.component';
import { RestoreHyperVWizardComponent } from 'wizards/remote-management-wizards/restore-hyper-v-wizard/restore-hyper-v-wizard.component';
import { RestoreVMWareWizardComponent } from 'wizards/remote-management-wizards/restore-vmware-wizard/restore-vmware-wizard.component';
import { SQLWizardComponent } from 'wizards/remote-management-wizards/sql-wizard/sql-wizard.component';
import { VMWareWizardComponent } from 'wizards/remote-management-wizards/vmware-wizard/vmware-wizard.component';

export function getWizardComponentType(type: PlanTypes) {
  switch (type) {
    case PlanTypes.Plan:
      return BackupFilesWizardComponent;
    case PlanTypes.BackupHyperV:
      return HyperVWizardComponent;
    case PlanTypes.BackupVMware:
      return VMWareWizardComponent;
    case PlanTypes.BackupDiskImagePlan:
      return ImageBasedWizardComponent;
    case PlanTypes.ConsistencyCheck:
      return ConsistencyCheckWizardComponent;
    case PlanTypes.DataBasePlan:
      return SQLWizardComponent;
    case PlanTypes.RestoreDataBasePlan:
    case PlanTypes.RestoreDatabaseFilesPlan:
      return DatabaseRestoreWizardComponent;
    case PlanTypes.RestorePlan:
      return RestoreFileWizardComponent;
    case PlanTypes.InstantRestoreHyperV:
    case PlanTypes.InstantRestoreProxmox:
    case PlanTypes.InstantRestoreMSP360LDR:
    case PlanTypes.RestoreDiskImagePlan:
      return ImageBasedRestoreWizardComponent;
    case PlanTypes.RestoreHyperV:
      return RestoreHyperVWizardComponent;
    case PlanTypes.RestoreVMware:
      return RestoreVMWareWizardComponent;
    case PlanTypes.RestoreHyperVToCustom:
      return RestoreHyperVWizardComponent;
    case PlanTypes.RestoreVMwareToCustom:
      return RestoreVMWareWizardComponent;
    case PlanTypes.BackupProxmox:
      return ProxmoxBackupWizardComponent;
    case PlanTypes.RestoreProxmox:
      return ProxmoxRestoreWizardComponent;
    default:
      return BackupFilesWizardComponent;
  }
}
